"use strict";
/** Polyfilling some common methods that are post-ES6 and not available in IE11 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectValues = void 0;
/** Polyfill for Object.values */
function objectValues(obj) {
    var keys = Object.keys(obj);
    return keys.map(function (key) { return obj[key]; });
}
exports.objectValues = objectValues;
//# sourceMappingURL=ObjectHelpers.js.map